import { render, staticRenderFns } from "./07-settings.vue?vue&type=template&id=6166c213"
import script from "./07-settings.vue?vue&type=script&lang=ts"
export * from "./07-settings.vue?vue&type=script&lang=ts"
import style0 from "./07-settings.vue?vue&type=style&index=0&id=6166c213&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports